var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisibilityFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M480.12-330q70.88 0 120.38-49.62t49.5-120.5-49.62-120.38-120.5-49.5-120.38 49.62-49.5 120.5 49.62 120.38 120.5 49.5m-.3-61.83q-45.15 0-76.57-31.6t-31.42-76.75 31.6-76.57 76.75-31.42 76.57 31.6 31.42 76.75-31.6 76.57-76.75 31.42M480-194.5q-147.91 0-267.35-84.67Q93.22-363.85 34.5-500q58.72-136.15 178.15-220.83Q332.09-805.5 480-805.5t267.35 84.67Q866.78-636.15 925.5-500q-58.72 136.15-178.15 220.83Q627.91-194.5 480-194.5"
})));
export default SvgVisibilityFill;